<template>
  <div>
    <h5 class="mb-3">
      {{ dataComponent.name }}
    </h5>

    <div class="d-flex align-items-center justify-content-between mt-5">
      <div>
        <b-button class="btn green outline m__r--5">Export Employee Historical</b-button>
        <b-button class="btn green outline">Generate Employee Data</b-button>
      </div>
      <b-button class="btn blue">Import Employee</b-button>
    </div>

    <!-- Button -->
    <div class="mt-4">
      <b-button
        class="btn grey btn-import-form m__r--5"
        disabled
      >
        <i class="fa fa-plus fa-lg"/> Add
      </b-button>
      <b-button
        class="btn grey btn-import-form"
        disabled
      >
        <i class="fa fa-search fa-lg"/> Search
      </b-button>
    </div>

    <!-- Columns -->
    <div class="columns mt-3">
      <div class="d-flex align-items-center">
        <div
          v-for="column in columns"
          :key="column"
          class="column"
        >
          <div
            class="header-list"
            style="cursor: default !important;"
          >
            <div class="column-name">{{ column }}</div>
          </div>
          <div
            v-for="index in 4"
            :key="index"
            :class="{'bg-gray': index === 2 || index === 4}"
            class="column-preview"
            style="cursor: default !important;"
          >
            <div class="content-preview"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataComponent: {
      type: Object,
      default: () => null,
    },
  },

  data() {
    return {
      columns: [
        'Staff Name',
        'Employee ID',
        'Team',
        'Last Send Invite Date',
        'Created Date',
        'Updated Date',
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/dummy/DummyEmployeeSetup.vue